import { api } from "roboflex-thalamus-request-handler";

const funções = {

 async listarProdutosCategoria(categoriaId) {
    const { data } = await api.get(`/dre/categoria/listarProdutos/${categoriaId}`);
    return data; 
  },

  async vincularProdutosCategoria(categoriaId, codigos) {
    const payload = { categoria_id: categoriaId, produtos: codigos };
    const { data } = await api.post(`/dre/categoria/vincularProdutos`, payload);
    return data;
  },

    async desvincularProdutosCategoria(categoriaId, codigos) {
    const payload = { categoria_id: categoriaId, produtos: codigos };
    const { data } = await api.post(`/dre/categoria/desvincularProdutos`, payload);
    return data;
  },

  // '1',  'Mercadoria para Revenda'
  // '2', 'Matéria Prima'
  // '3', 'Embalagem'
  // '4', 'Produto em Processo'
  // '5', 'Produto Acabado'
  // '6', 'Subproduto',
  // '7', 'Produto Intermediário',
  // '8' , 'Material de Uso e Consumo',
  // '9', 'Ativo Imobilizado',
  // '10, 'Serviços',
  // '11', 'Outros Insumos',
  // '12, 'Outras',
  async filtrarProdutos(payload) {
    return await api.get("/produto-filtrar", { params: payload });
  },

  async setEditavel(produto_cod, flag) {
    try {
      const { data } = await api.patch(`/produto/editavel/${produto_cod}`, { editavel: !!flag });
      return data;
    } catch (error) {
      console.error("Erro ao alterar flag editavel:", error);
      throw error;
    }
  },

  async getProdutosPorCategoria(tipos) {
    try {
      const payload = {
        tipo: tipos,
      };

      const responseProdutos = await api.get(`/produto-filtrar`, {
        params: payload,
      });

      return responseProdutos.data;
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      throw error;
    }
  },

  async getProdutos(pagina = 1) {
    try {
      const payload = {
        tipo: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        paginacao: 1,
        page: pagina,
        //editavel: false, //comentado para nova lógica
      };

      const response = await api.get(`/produto-filtrar`, { params: payload });
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      throw error;
    }
  },

  async getProdutoByCod(cod) {
    try {
      const response = await api.get(`/produto-buscar/${cod}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      throw error;
    }
  },


  async listarProdutosComPaginacao({ searchQuery = "", filtroTipo = "", filtroFamilia = "", pagina = 1 } = {}) {
    try {
      // base de filtros: sempre manda "tipo"
      const base = {
        tipo: filtroTipo ? [filtroTipo] : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      };

      // manda "termo"
      // - senão, paginação e "familia"
      const params =
        searchQuery && searchQuery.trim()
          ? { ...base, termo: searchQuery.trim() }
          : {
            ...base,
            ...(filtroFamilia ? { familia: filtroFamilia } : {}),
            paginacao: 1,
            page: pagina,
          };

      const { data } = await api.get(`/produto-filtrar`, { params });

      const items = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];

      const totalPages = data?.last_page ?? data?.meta?.last_page ?? data?.meta?.total_pages ?? data?.total_paginas ?? null;

      const currentPage = data?.current_page ?? data?.meta?.current_page ?? (totalPages ? pagina : 1);

      return { items, totalPages, currentPage };
    } catch (error) {
      console.error("Erro ao listar produtos:", error);
      throw error;
    }
  },

  async getTipoeFamilias() {
    try {
      const payload = {
        tipo: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      };

      const responseProdutos = await api.get(`/produto-filtrar`, {
        params: payload,
      });

      const tipos = responseProdutos.data
        .map((produto) => produto.tipo)
        .reduce((acc, tipo) => {
          if (tipo && !acc.some((t) => t.id === tipo.id)) {
            acc.push(tipo);
          }
          return acc;
        }, []);

      const familias = responseProdutos.data
        .map((produto) => produto.familia_produto)
        .reduce((acc, familia) => {
          if (familia && !acc.some((f) => f.id === familia.id)) {
            acc.push(familia);
          }
          return acc;
        }, []);

      return { tipos, familias };
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      throw error;
    }
  },


  async getTipoProduto() {
    try {
      const response = await api.get(`produto/tipo/listar`);
      return response.data;
    } catch (error) {
      console.error("Erro ao listar produtos");
      throw error;
    }
  },


};

export default funções;
